{
  "version": 1,
  "asset_id": "6516d957-e682-4fec-b0b4-73d9f4bc70f4",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/6516d957-e682-4fec-b0b4-73d9f4bc70f4/revision-hub-annotated-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/6516d957-e682-4fec-b0b4-73d9f4bc70f4/revision-hub-annotated-800.jpg",
  "original_filename": "revision-hub-annotated-800.jpg",
  "size": 69135,
  "content_type": "image/jpeg",
  "created_at": "2026-10-05T21:16:37Z"
}
